import { render, staticRenderFns } from "./OrderListTable.vue?vue&type=template&id=41248355&"
import script from "./OrderListTable.vue?vue&type=script&lang=js&"
export * from "./OrderListTable.vue?vue&type=script&lang=js&"
import style0 from "./OrderListTable.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports